module.exports = __webpack_public_path__ + "img/icon-screening-menu-covid.3c0e3d02.svg";